const STORAGE_KEY = 'ph_persisted_notification_v1';

export const queuePersistedNotification = (notification) => {
    try {
        if (typeof window === 'undefined' || !window.sessionStorage) return;
        window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(notification));
    } catch (e) {
        // no-op: storage may be unavailable (privacy mode, disabled, etc.)
    }
};

export const consumePersistedNotification = () => {
    try {
        if (typeof window === 'undefined' || !window.sessionStorage) return null;
        const raw = window.sessionStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        window.sessionStorage.removeItem(STORAGE_KEY);
        return JSON.parse(raw);
    } catch (e) {
        return null;
    }
};

